var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 52,
    viewBox: "0 0 58 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3055 1.07495C49.5146 1.07495 51.3055 2.86581 51.3055 5.07495V46.5171C51.3055 48.7263 49.5146 50.5171 47.3055 50.5171H10.6951C8.48593 50.5171 6.69507 48.7263 6.69507 46.5171V17.8181L26.0909 1.07495H47.3055ZM29.5512 22.7986C29.083 22.4958 28.4142 22.4958 27.946 22.7986C25.8726 24.1913 24.4681 25.2208 23.5318 26.0685C22.9967 26.4924 22.9967 27.2796 23.5318 27.764C24.0668 28.2485 24.8694 28.2485 25.4045 27.764C25.8726 27.3401 26.5415 26.7952 27.4109 26.1896V32.7294C27.4109 33.3955 28.0129 33.9405 28.7486 33.9405C29.4843 33.9405 30.0862 33.3955 30.0862 32.7294V26.1896C30.8888 26.7952 31.5576 27.3401 32.0258 27.764C32.2933 28.0062 32.6277 28.1273 32.9622 28.1273C33.2966 28.1273 33.631 28.0062 33.8985 27.764C34.4336 27.2796 34.4336 26.5529 33.8985 26.0685C33.029 25.2208 31.5576 24.1913 29.5512 22.7986ZM20.7826 37.5442C20.7826 36.9919 21.2303 36.5442 21.7826 36.5442H36.218C36.7703 36.5442 37.218 36.9919 37.218 37.5442V37.6938C37.218 38.2461 36.7703 38.6938 36.218 38.6938H21.7826C21.2303 38.6938 20.7826 38.2461 20.7826 37.6938V37.5442ZM25.6896 15.5777V4.46606L10.8418 17.3943H23.6831C24.8201 17.3943 25.6896 16.6071 25.6896 15.5777Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImport);
export default __webpack_public_path__ + "static/media/icon-import.e0488bb16ee954bc3fc520e67f721d40.svg";
export { ForwardRef as ReactComponent };